/**
 *
 * History
 *
 */
import { useNavigate } from 'react-router-dom';

import History from '..';

export const HistoryComponent = () => {
  History.navigate = useNavigate();
  return null;
};
